import AboutUs from "../AboutUs";

function JppAboutUs() {
  return (
    <AboutUs
      className="JC about"
      titleKey="jpp.about.title"
      textKey="jpp.about.text"
    />
  );
}

export default JppAboutUs;
